const paymentsSelector = (state: any) => ({
  submitting: state.paymentsReducer.submitting,
});

export default paymentsSelector;
